import convert from 'color-convert';
import _ from 'lodash';

export const defaultColors = {
	'--global-container-size-big': '96rem',
	'--global-container-size-small': '96rem',
	'--global-desktop-padding': '1rem',
	'--global-mobile-padding': '0.5rem',
	'--global-login-border-radius': 'var(--border-radius-lg)',
	'--global-border-radius': 'var(--border-radius-sm)',
	'--global-orders-border-radius': 'var(--border-radius-none)',
	'--global-login-button-fs': 'var(--font-size-sm)',
	'--global-login-button-fw': 'var(--font-weight-400)',
	'--global-login-button-ff': 'var(--main-font)',
	'--global-login-title-fs': 'var(--font-size-md)',
	'--global-login-title-fw': 'var(--font-weight-400)',
	'--global-login-title-ff': 'var(--main-font)',
	'--brand-color-primary-pure': '#FCb816',
	'--brand-color-secondary-pure': '#353535',
	'--cta-color-pure': '#00c271',
	'--support-color-1': '#F26F25',
	'--support-color-2': '#00ADC5',
	'--support-color-3': '#ff6464',
	'--support-color-4': '#1F6ECB',
	'--feedback-color-success': '#AFE86D',
	'--feedback-color-warning': '#FFC545',
	'--feedback-color-error': '#FF6B6B',
	'--text-color-1': '#222222',
	'--grad-1': 'linear-gradient(to right,#ffffff, #440040)',
	'--grad-2': 'linear-gradient(to right,#ffffff, #440040)',
	//fonts
	'--font-size-base': '0.875rem',
	'--font-title-base': '2.625rem',
	'--lighter': '300',
	'--regular': '400',
	'--normal': '500',
	'--semi-bold': '600',
	'--bold': '700',
	'--extra-bold': '800',
	'--font-size-ico-1': '2.813rem',
	'--font-size-ico-2': '2.938rem',
	'--font-size-ico-3': '3.5rem',
	'--font-c-1': '2.5rem',
	'--main-font': 'sans-serif',
	'--main-font-2': 'sans-serif',

	//NAO ALTERAR ESSAS VARIAVEIS
	'--transparent': 'transparent',
	//br
	'--border-radius-none': '0',
	'--border-radius-xs': '0.25rem',
	'--border-radius-sm': '0.5rem',
	'--border-radius-md': '1rem',
	'--border-radius-lg': '1.5rem',
	'--border-radius-pill': '500px',
	'--border-radius-circular': '50%',
	//bw
	'--border-width-none': '0px',
	'--border-width-hairline': '1px',
	'--border-width-thin': '0.125rem',
	'--border-width-thick': '0.25rem',
	'--border-width-heavy': '0.5rem',

	'--black': '#000000',
	'--neutral-color-low-pure': '#000000',
	'--neutral-color-low-light': '#a3a3a3',
	'--neutral-color-low-medium': '#666666',
	'--neutral-color-low-dark': '#292929',
	'--white': '#ffffff',
	'--neutral-color-high-pure': '#ffffff',
	'--neutral-color-high-light': '#f5f5f5',
	'--neutral-color-high-medium': '#e0e0e0',
	'--neutral-color-high-dark': '#cccccc',

	//fontsize
	'--font-size-xxxs': '0.625rem',
	'--font-size-xxs': '0.75rem',
	'--font-size-xs': '0.875rem',
	'--font-size-sm': '1rem',
	'--font-size-md': '1.125rem',
	'--font-size-lg': '1.313rem',
	'--font-size-xl': '1.5rem',
	'--font-size-xxl': '2rem',
	'--font-size-xxxl': '2.5rem',
	'--font-size-display': '3rem',
	'--font-size-giant': '4rem',
	'--font-size-titan': '4.5rem',

	//fontweight
	'--font-weight-200': '200',
	'--font-weight-300': '300',
	'--font-weight-400': '400',
	'--font-weight-500': '500',
	'--font-weight-600': '600',
	'--font-weight-700': '700',
	'--font-weight-900': '900',

	//Spacing
	'--spacing-atom': '0.25rem',
	'--spacing-nano': '0.5rem',
	'--spacing-xxxs': '1rem',
	'--spacing-xxs': '1.5rem',
	'--spacing-xs': '2rem',
	'--spacing-sm': '2.5rem',
	'--spacing-md': '3rem',
	'--spacing-lg': '3.5rem',
	'--spacing-xl': '4rem',
	'--spacing-xxl': '5rem',
	'--spacing-xxxl': '7.5rem',
	'--spacing-giant': '10rem',
	'--spacing-titan': '12.5rem',
	//internal spacing
	'--spacing-inset-atom': '0.25rem',
	'--spacing-inset-nano': '0.5rem',
	'--spacing-inset-xs': '1rem',
	'--spacing-inset-sm': '1.5rem',
	'--spacing-inset-md': '2rem',
	'--spacing-inset-lg': '2.5rem',
	//opacity

	'--opacity-level-transparent': 0,
	'--opacity-level-semitransparent': 0.08,
	'--opacity-level-light': 0.16,
	'--opacity-level-medium': 0.32,
	'--opacity-level-intense': 0.64,
	'--opacity-level-semiopaque': 0.72,
	'--opacity-level-opaque': 1,

	//STYLE JSON
	'--semanticColors---background---base': '#ffffff',
	'--semanticColors---background---base--inverted': '#000000',
	'--semanticColors---background---action-primary': 'var(--cta-color-pure)',
	'--semanticColors---background---action-secondary': '#eef3f7',
	'--semanticColors---background---emphasis': '#f71963',
	'--semanticColors---background---disabled': '#f2f4f5',
	'--semanticColors---background---success': 'var(--feedback-color-success)',
	'--semanticColors---background---success--faded': 'var(--feedback-color-success-light)',
	'--semanticColors---background---danger': 'var(--feedback-color-error)',
	'--semanticColors---background---danger--faded': 'var(--feedback-color-error-light)',
	'--semanticColors---background---warning': 'var(--feedback-color-warning)',
	'--semanticColors---background---warning--faded': 'var(--feedback-color-warning-light)',
	'--semanticColors---background---muted-1': '#727273',
	'--semanticColors---background---muted-2': '#979899',
	'--semanticColors---background---muted-3': '#cacbcc',
	'--semanticColors---background---muted-4': '#e3e4e6',
	'--semanticColors---background---muted-5': '#f2f4f5',
	'--semanticColors---hover-background---action-primary': 'var(--cta-color-hover)',
	'--semanticColors---hover-background---action-secondary': 'var(--neutral-color-high-light)',
	'--semanticColors---hover-background---emphasis': '#dd1659',
	'--semanticColors---hover-background---success': 'var(--feedback-color-success-medium)',
	'--semanticColors---hover-background---success--faded': 'var(--feedback-color-success-light)',
	'--semanticColors---hover-background---danger': 'var(--feedback-color-error)',
	'--semanticColors---hover-background---danger--faded': 'var(--feedback-color-error-light)',
	'--semanticColors---hover-background---warning': 'var(--feedback-color-warning)',
	'--semanticColors---hover-background---warning--faded': 'var(--feedback-color-warning-light)',
	'--semanticColors---hover-background---muted-1': '#727273',
	'--semanticColors---hover-background---muted-2': '#979899',
	'--semanticColors---hover-background---muted-3': '#cacbcc',
	'--semanticColors---hover-background---muted-4': '#e3e4e6',
	'--semanticColors---hover-background---muted-5': '#f2f4f5',
	'--semanticColors---active-background---action-primary': 'var(--cta-color-focus)',
	'--semanticColors---active-background---action-secondary': '#d2defc',
	'--semanticColors---active-background---emphasis': '#dd1659',
	'--semanticColors---active-background---success': 'var(--feedback-color-success-dark)',
	'--semanticColors---active-background---success--faded': 'var(--feedback-color-success-light)',
	'--semanticColors---active-background---danger': 'var(--feedback-color-error-dark)',
	'--semanticColors---active-background---danger--faded': 'var(--feedback-color-error-light)',
	'--semanticColors---active-background---warning': 'var(--feedback-color-warning-dark)',
	'--semanticColors---active-background---warning--faded': 'var(--feedback-color-warning-light)',
	'--semanticColors---active-background---muted-1': '#727273',
	'--semanticColors---active-background---muted-2': '#979899',
	'--semanticColors---active-background---muted-3': '#cacbcc',
	'--semanticColors---active-background---muted-4': '#e3e4e6',
	'--semanticColors---active-background---muted-5': '#f2f4f5',
	'--semanticColors---text---action-primary': 'var(--text-color-1)',
	'--semanticColors---text---action-secondary': 'var(--white)',
	'--semanticColors---text---link': 'var(--cta-color-hover)',
	'--semanticColors---text---emphasis': '#f71963',
	'--semanticColors---text---disabled': '#979899',
	'--semanticColors---text---success': 'var(--text-color-1)',
	'--semanticColors---text---success--faded': 'var(--text-color-1)',
	'--semanticColors---text---danger': 'var(--text-color-1)',
	'--semanticColors---text---danger--faded': 'var(--text-color-1)',
	'--semanticColors---text---warning': 'var(--text-color-1)',
	'--semanticColors---text---warning--faded': 'var(--text-color-1)',
	'--semanticColors---text---muted-1': '#727273',
	'--semanticColors---text---muted-2': '#979899',
	'--semanticColors---text---muted-3': '#cacbcc',
	'--semanticColors---text---muted-4': '#e3e4e6',
	'--semanticColors---text---muted-5': '#f2f4f5',
	'--semanticColors---visited-text---link': 'blue',
	'--semanticColors---hover-text---action-primary': '#FFFFFF',
	'--semanticColors---hover-text---action-secondary': 'var(--cta-color-hover)',
	'--semanticColors---hover-text---link': 'var(--cta-color-hover)',
	'--semanticColors---hover-text---emphasis': '#dd1659',
	'--semanticColors---hover-text---success': 'var(--text-color-1)',
	'--semanticColors---hover-text---success--faded': 'var(--text-color-1)',
	'--semanticColors---hover-text---danger': 'var(--text-color-1)',
	'--semanticColors---hover-text---danger--faded': 'var(--text-color-1)',
	'--semanticColors---hover-text---warning': 'var(--text-color-1)',
	'--semanticColors---hover-text---warning--faded': 'var(--text-color-1)',
	'--semanticColors---active-text---link': 'blue',
	'--semanticColors---active-text---emphasis': '#dd1659',
	'--semanticColors---active-text---success': 'var(--text-color-1)',
	'--semanticColors---active-text---success--faded': 'var(--text-color-1)',
	'--semanticColors---active-text---danger': 'var(--text-color-1)',
	'--semanticColors---active-text---danger--faded': 'var(--text-color-1)',
	'--semanticColors---active-text---warning': 'var(--text-color-1)',
	'--semanticColors---active-text---warning--faded': 'var(--text-color-1)',
	'--semanticColors---border---action-primary': 'var(--cta-color-pure)',
	'--semanticColors---border---action-secondary': 'var(--cta-color-pure)',
	'--semanticColors---border---emphasis': '#f71963',
	'--semanticColors---border---disabled': '#e3e4e6',
	'--semanticColors---border---success': '#79B03A',
	'--semanticColors---border---success--faded': '#eafce3',
	'--semanticColors---border---danger': 'chocolate',
	'--semanticColors---border---danger--faded': '#ffe6e6',
	'--semanticColors---border---warning': 'chocolate',
	'--semanticColors---border---warning--faded': '#fff6e0',
	'--semanticColors---border---muted-1': '#727273',
	'--semanticColors---border---muted-2': '#979899',
	'--semanticColors---border---muted-3': '#cacbcc',
	'--semanticColors---border---muted-4': '#e3e4e6',
	'--semanticColors---border---muted-5': '#f2f4f5',
	'--semanticColors---hover-border---action-primary': 'var(--cta-color-hover)',
	'--semanticColors---hover-border---action-secondary': 'var(--cta-color-hover)',
	'--semanticColors---hover-border---emphasis': '#dd1659',
	'--semanticColors---hover-border---success': '#79B03A',
	'--semanticColors---hover-border---success--faded': '#eafce3',
	'--semanticColors---hover-border---danger': '#e13232',
	'--semanticColors---hover-border---danger--faded': '#ffe6e6',
	'--semanticColors---hover-border---warning': '#E19D00',
	'--semanticColors---hover-border---warning--faded': '#fff6e0',
	'--semanticColors---hover-border---muted-1': '#727273',
	'--semanticColors---hover-border---muted-2': '#979899',
	'--semanticColors---hover-border---muted-3': '#cacbcc',
	'--semanticColors---hover-border---muted-4': '#e3e4e6',
	'--semanticColors---hover-border---muted-5': '#f2f4f5',
	'--semanticColors---active-border---action-primary': 'var(--cta-color-focus)',
	'--semanticColors---active-border---action-secondary': 'var(--cta-color-focus)',
	'--semanticColors---active-border---emphasis': '#dd1659',
	'--semanticColors---active-border---success': '#79B03A',
	'--semanticColors---active-border---success--faded': '#eafce3',
	'--semanticColors---active-border---danger': 'chocolate',
	'--semanticColors---active-border---danger--faded': '#ffe6e6',
	'--semanticColors---active-border---warning': '#E19D00',
	'--semanticColors---active-border---warning--faded': '#fff6e0',
	'--semanticColors---active-border---muted-1': '#727273',
	'--semanticColors---active-border---muted-2': '#979899',
	'--semanticColors---active-border---muted-3': '#cacbcc',
	'--semanticColors---active-border---muted-4': '#e3e4e6',
	'--semanticColors---active-border---muted-5': '#f2f4f5',
	'--semanticColors---on---base': 'var(--text-color-1)',
	'--semanticColors---on---base--inverted': '#ffffff',
	'--semanticColors---on---action-primary': '#ffffff',
	'--semanticColors---on---action-secondary': 'var(--cta-color-hover)',
	'--semanticColors---on---emphasis': '#ffffff',
	'--semanticColors---on---disabled': 'var(--text-color-1-dark)',
	'--semanticColors---on---success': 'var(--text-color-1)',
	'--semanticColors---on---success--faded': 'var(--text-color-1)',
	'--semanticColors---on---danger': 'var(--text-color-1)',
	'--semanticColors---on---danger--faded': 'var(--text-color-1)',
	'--semanticColors---on---warning': 'var(--text-color-1)',
	'--semanticColors---on---warning--faded': 'var(--text-color-1)',
	'--semanticColors---on---muted-1': '#ffffff',
	'--semanticColors---on---muted-2': '#ffffff',
	'--semanticColors---on---muted-3': 'var(--text-color-1)',
	'--semanticColors---on---muted-4': 'var(--text-color-1)',
	'--semanticColors---on---muted-5': 'var(--text-color-1)',
	'--semanticColors---hover-on---action-primary': '#ffffff',
	'--semanticColors---hover-on---action-secondary': 'var(--cta-color-hover)',
	'--semanticColors---hover-on---emphasis': '#ffffff',
	'--semanticColors---hover-on---success': 'var(--text-color-1)',
	'--semanticColors---hover-on---success--faded': 'var(--text-color-1)',
	'--semanticColors---hover-on---danger': 'var(--text-color-1)',
	'--semanticColors---hover-on---danger--faded': 'var(--text-color-1)',
	'--semanticColors---hover-on---warning': 'var(--text-color-1)',
	'--semanticColors---hover-on---warning--faded': 'var(--text-color-1)',
	'--semanticColors---active-on---action-primary': '#ffffff',
	'--semanticColors---active-on---action-secondary': 'var(--cta-color-hover)',
	'--semanticColors---active-on---emphasis': '#ffffff',
	'--semanticColors---active-on---success': 'var(--text-color-1)',
	'--semanticColors---active-on---success--faded': 'var(--text-color-1)',
	'--semanticColors---active-on---danger': 'var(--text-color-1)',
	'--semanticColors---active-on---danger--faded': 'var(--text-color-1)',
	'--semanticColors---active-on---warning': 'var(--text-color-1)',
	'--semanticColors---active-on---warning--faded': 'var(--text-color-1)',
	'--typography---heading-1---fontFamily':
		'var(--main-font), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---heading-1---fontWeight': '700',
	'--typography---heading-1---fontSize': '3rem',
	'--typography---heading-1---textTransform': 'initial',
	'--typography---heading-1---letterSpacing': '0',
	'--typography---heading-2---fontFamily':
		'var(--main-font), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---heading-2---fontWeight': '700',
	'--typography---heading-2---fontSize': '2.25rem',
	'--typography---heading-2---textTransform': 'initial',
	'--typography---heading-2---letterSpacing': '0',
	'--typography---heading-3---fontFamily':
		'var(--main-font), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---heading-3---fontWeight': '700',
	'--typography---heading-3---fontSize': '1.75rem',
	'--typography---heading-3---textTransform': 'initial',
	'--typography---heading-3---letterSpacing': '0',
	'--typography---heading-4---fontFamily':
		'var(--main-font), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---heading-4---fontWeight': 'normal',
	'--typography---heading-4---fontSize': '1.5rem',
	'--typography---heading-4---textTransform': 'initial',
	'--typography---heading-4---letterSpacing': '0',
	'--typography---heading-5---fontFamily':
		'var(--main-font), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---heading-5---fontWeight': 'normal',
	'--typography---heading-5---fontSize': '1.25rem',
	'--typography---heading-5---textTransform': 'initial',
	'--typography---heading-5---letterSpacing': '0',
	'--typography---heading-6---fontFamily':
		'var(--main-font), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---heading-6---fontWeight': 'normal',
	'--typography---heading-6---fontSize': '1rem',
	'--typography---heading-6---textTransform': 'initial',
	'--typography---heading-6---letterSpacing': '0',
	'--typography---body---fontFamily':
		'var(--main-font-2), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---body---fontWeight': 'normal',
	'--typography---body---fontSize': '1rem',
	'--typography---body---textTransform': 'initial',
	'--typography---body---letterSpacing': '0',
	'--typography---small---fontFamily':
		'var(--main-font-2), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---small---fontWeight': 'normal',
	'--typography---small---fontSize': '0.875rem',
	'--typography---small---textTransform': 'initial',
	'--typography---small---letterSpacing': '0',
	'--typography---mini---fontFamily':
		'var(--main-font-2), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---mini---fontWeight': 'normal',
	'--typography---mini---fontSize': '0.75rem',
	'--typography---mini---textTransform': 'initial',
	'--typography---mini---letterSpacing': '0',
	'--typography---action---fontFamily':
		'var(--main-font-2), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---action---fontWeight': '500',
	'--typography---action---fontSize': '1rem',
	'--typography---action---textTransform': 'initial',
	'--typography---action---letterSpacing': '0',
	'--typography---action--small---fontFamily':
		'var(--main-font-2), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---action--small---fontWeight': '500',
	'--typography---action--small---fontSize': '0.875rem',
	'--typography---action--small---textTransform': 'initial',
	'--typography---action--small---letterSpacing': '0',
	'--typography---action--large---fontFamily':
		'var(--main-font-2), -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif',
	'--typography---action--large---fontWeight': '500',
	'--typography---action--large---fontSize': '1.25rem',
	'--typography---action--large---textTransform': 'initial',
	'--typography---action--large---letterSpacing': '0',
	'--typography---code---fontFamily': 'Consolas, monaco, monospace',
	'--typography---code---fontWeight': 'normal',
	'--typography---code---fontSize': '1rem',
	'--typography---code---textTransform': 'initial',
	'--typography---code---letterSpacing': '0',
};

const colorVariationFeedbackArr = [
	{ suffix: '-light', amount: 16 },
	{ suffix: '-medium', amount: 8 },
	{ suffix: '-dark', amount: -15 },
];

const colorVariationArrBatuta = [
	{ suffix: '-light', amount: 20 },
	{ suffix: '-medium', amount: 8 },
	{ suffix: '-dark', amount: -10 },
];
const colorVariationArrBatutaCTA = [
	{ suffix: '-focus', amount: 20 },
	{ suffix: '-hover', amount: -10 },
	{ suffix: '-disabled', amount: 0.5, type: 'rgba' },
];

// const fontVariationsArr=[
//     {name:'--font-size-xxs',amount:0.7,roundTo:'ceil'},
//     {name:'--font-size-xs',amount:0.85,roundTo:'ceil'},
//     {name:'--font-size-sm',amount:1,roundTo:'ceil'},
//     {name:'--font-size-md',amount:1.15,roundTo:'floor'},
//     {name:'--font-size-lg',amount:1.3,roundTo:'floor'},
//     {name:'--font-size-xlg',amount:1.45,roundTo:'floor'},
// ]

const titleVariationArr = [
	{ name: '--font-size-h1', amount: 1, roundTo: 'ceil' },
	{ name: '--font-size-h2', amount: 0.87, roundTo: 'ceil' },
	{ name: '--font-size-h3', amount: 0.74, roundTo: 'ceil' },
	{ name: '--font-size-h4', amount: 0.61, roundTo: 'ceil' },
	{ name: '--font-size-h5', amount: 0.48, roundTo: 'ceil' },
	{ name: '--font-size-h6', amount: 0.35, roundTo: 'ceil' },
];

function alterColor(color, amt) {
	const colorHSL = convert.hex.hsl(color);

	colorHSL[2] += amt;
	if (colorHSL[2] <= 0) colorHSL[2] = 0;
	if (colorHSL[2] >= 100) colorHSL[2] = 100;

	return convert.hsl.hex(colorHSL);
}

function sassRgba(hex, alpha) {
	const { r, g, b } = hexToRgb(hex);
	return `rgba(${r},${g},${b},${alpha})`;
}
function hexToRgb(hex) {
	var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16),
			}
		: null;
}

function colorVariationsBatuta(colorName, hexColor) {
	const result = colorVariationArrBatuta.map((variation) => {
		return {
			[colorName.replace('-pure', '') + variation.suffix]: '#' + alterColor(hexColor, variation.amount),
		};
	});
	return Object.assign({}, ...result);
}

function colorVariationsBatutaCTA(colorName, hexColor) {
	const result = colorVariationArrBatutaCTA.map((variation) => {
		if (variation.type == 'rgba') {
			return { [colorName.replace('-pure', '') + variation.suffix]: sassRgba(hexColor, variation.amount) };
		} else {
			return {
				[colorName.replace('-pure', '') + variation.suffix]: '#' + alterColor(hexColor, variation.amount),
			};
		}
	});
	return Object.assign({}, ...result);
}
function colorVariationFeedback(colorName, hexColor) {
	const result = colorVariationFeedbackArr.map((variation) => {
		return {
			[colorName + variation.suffix]: '#' + alterColor(hexColor, variation.amount),
		};
	});
	return Object.assign({}, ...result);
}

function generateFeedbackVariations(variables) {
	const colors = ['--feedback-color-success', '--feedback-color-warning', '--feedback-color-error'];
	const result = colors.map((color) => colorVariationFeedback(color, variables[color]));
	return Object.assign({}, ...result);
}
function generateColorVariationsBatuta(variables) {
	const colors = ['--brand-color-primary-pure', '--brand-color-secondary-pure', '--text-color-1'];
	const result = colors.map((color) => colorVariationsBatuta(color, variables[color]));
	return Object.assign({}, ...result);
}
function generateColorVariationsBatutaCTA(variables) {
	const colors = ['--cta-color-pure'];
	const result = colors.map((color) => colorVariationsBatutaCTA(color, variables[color]));
	return Object.assign({}, ...result);
}

// function generateFontVariations(variables){
//     const baseSize = ['--font-size-base']
//     let result = baseSize.map(size=>fontVariations(variables[size]))
//     return Object.assign({},...result)
// }

// function fontVariations(size){
//     let result = fontVariationsArr.map(v=>{
//         let sizeNumber = parseFloat(size)*v.amount || 1
//         return {
//             [v.name]:Math[v.roundTo](sizeNumber)+'px'
//         }
//     })
//     return Object.assign({},...result)
// }

function generateTitleVariations(variables) {
	const baseSize = ['--font-title-base'];
	const result = baseSize.map((size) => titleVariations(variables[size]));
	return Object.assign({}, ...result);
}

function generateCustomFonts(variables) {
	const baseSize = ['--font-c-1'];
	const result = baseSize.map((size) => {
		return { [size]: parseFloat(variables[size]) / 4 + 'rem' };
	});
	return Object.assign({}, ...result);
}

function titleVariations(size) {
	const result = titleVariationArr.map((v) => {
		const sizeNumber = parseFloat(size) * v.amount || 1;
		return {
			[v.name]: Math[v.roundTo](sizeNumber) / 4 + 'rem',
		};
	});
	return Object.assign({}, ...result);
}

function generateVariations(variables) {
	return {
		...generateColorVariationsBatuta(variables),
		...generateColorVariationsBatutaCTA(variables),
		// ...generateFontVariations(variables),
		...generateTitleVariations(variables),
		...generateCustomFonts(variables),
		...generateFeedbackVariations(variables),
	};
}

function generateCSSGlobalVariables(colors) {
	//caso venha do bd
	let variables;
	if (colors && !_.isEmpty(colors)) {
		variables = { ...colors };
	} else {
		variables = { ...defaultColors };
	}
	return Object.assign(variables, generateVariations(variables));
}

export default generateCSSGlobalVariables;

export function assignNewVariables(definedVariables = {}) {
	const variables = { ...defaultColors };
	const newVariables = Object.assign(variables, generateVariations(variables));
	return Object.assign(newVariables, definedVariables);
}
